import { LogOut } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { clearAuthSession, getPreferredUsername } from '@/features/auth/session';

function initials(username: string): string {
  const parts = username.split(/[.\s@]+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0]?.[0] ?? ''}${parts[1]?.[0] ?? ''}`.toUpperCase();
  return username.slice(0, 2).toUpperCase();
}

export function UserMenu() {
  const navigate = useNavigate();
  const username = getPreferredUsername();
  if (!username) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label="Menu do usuário" className="cursor-pointer">
          <Avatar size="sm">
            <AvatarFallback>{initials(username)}</AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <div className="px-2 py-1.5">
          <p className="truncate text-sm font-medium">{username}</p>
        </div>
        <DropdownMenuItem
          onSelect={() => {
            clearAuthSession();
            void navigate({ to: '/login' });
          }}
        >
          <LogOut />
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
